import { render, staticRenderFns } from "./ExamSummary.vue?vue&type=template&id=48731732&scoped=true"
import script from "./ExamSummary.vue?vue&type=script&lang=js"
export * from "./ExamSummary.vue?vue&type=script&lang=js"
import style0 from "./ExamSummary.vue?vue&type=style&index=0&id=48731732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48731732",
  null
  
)

export default component.exports